import { render, staticRenderFns } from "./NewIQCSeleItemAdmin.vue?vue&type=template&id=b72b3416&scoped=true"
import script from "./NewIQCSeleItemAdmin.vue?vue&type=script&lang=js"
export * from "./NewIQCSeleItemAdmin.vue?vue&type=script&lang=js"
import style0 from "./NewIQCSeleItemAdmin.vue?vue&type=style&index=0&id=b72b3416&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72b3416",
  null
  
)

export default component.exports